<script lang="ts">
	import Button from '#components/button.svelte'
	import type { Blok, Button as IButton } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<IButton>
	}

	let { blok }: Props = $props()
	let { link, large, outline } = $derived(blok)
</script>

{#if link?.url}
	<Button href={link.url} {large} {outline} icon="next">{link.text}</Button>
{/if}
